import toast from 'react-hot-toast';
import { configure, createApiClient, handleApiError, queryParams } from '../../../shared/src/apiClient';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Platform bindings so the shared client can run in the browser.
configure({
  getToken: () => localStorage.getItem('token'),
  clearSession: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
  onUnauthorized: () => {
    window.location.href = '/login';
  },
  notify: (message, type) => {
    if (type === 'error') toast.error(message);
    else toast.success(message);
  },
});

const api = createApiClient(API_BASE_URL);

export default api;
export { handleApiError, queryParams };
